const apiUrl = process.env.REACT_APP_API_URL;
export const PostRol = async ( id : number | null, nom : string , page : string, id_usu_log : string  ) => {
    try {
        const response = await fetch(`${apiUrl}:8071/usuaris/rol/${id_usu_log}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            },
            body: JSON.stringify({id, nom})
        });
        if (!response.ok) {
            alert(await response.text());
        }

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
